const MAX_FACTORY_SEED = 2_147_483_000;

export { factoryDiversityBriefFor } from '#lib/list/factoryDiversity';

export interface FactoryLaunch<T> {
  source: T;
  seed: number;
  ratioLabel?: string;
}

interface FactoryGenerationLaunch {
  seed: number;
  ratioLabel?: string;
}

export const buildFactoryGenerationPlan = (
  total: number,
  ratioLabels: readonly string[] = [],
  random: () => number = Math.random,
): FactoryGenerationLaunch[] => {
  if (!Number.isInteger(total) || total <= 0) return [];
  const ratios = ratioLabels.length > 0 ? ratioLabels : [undefined];
  return Array.from({ length: total }, (_, index) => ({
    seed: Math.floor(random() * MAX_FACTORY_SEED),
    ratioLabel: ratios[index % ratios.length],
  }));
};

export const buildFactoryLaunchPlan = <T>(
  sources: readonly T[],
  total: number,
  random: () => number = Math.random,
  ratioLabels: readonly string[] = [],
): FactoryLaunch<T>[] => {
  if (sources.length === 0 || total === 0) return [];
  const ratios = ratioLabels.length > 0 ? ratioLabels : [undefined];

  return Array.from({ length: total }, (_, index) => ({
    source: sources[index % sources.length]!,
    seed: Math.floor(random() * MAX_FACTORY_SEED),
    ratioLabel: ratios[index % ratios.length],
  }));
};

export const buildFactoryUrlLaunchPlan = (
  sources: readonly unknown[],
  total: number,
  ratioLabelsOrRandom: readonly string[] | (() => number) = [],
  random: () => number = Math.random,
): FactoryLaunch<string>[] => {
  const normalized = sources.map((source) => typeof source === 'string' ? source.trim() : '');
  if (normalized.length === 0 || normalized.some((source) => source.length === 0)) return [];
  const ratioLabels = typeof ratioLabelsOrRandom === 'function' ? [] : ratioLabelsOrRandom;
  const randomFn = typeof ratioLabelsOrRandom === 'function' ? ratioLabelsOrRandom : random;
  return buildFactoryLaunchPlan(normalized, total, randomFn, ratioLabels);
};
